import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from "@angular/core";

@Component({
  selector: "grid-wizard-row",
  styles: [
    `
      .wizard-box {
        height: 400px;
        overflow-y: auto;
        border: 1px solid gray;
      }
      .wizard-item {
        cursor: pointer;
        padding: 0.25em 0.5em;
        background: #fff;
      }

      .wizard-item:nth-child(2n) {
        background: #e8e8e8;
      }

      .wizard-item.current {
        color: #0000ff;
        background: #87cefa;
      }
    `,
  ],
  template: ` <div style="display: flex; flex-direction: row;">
      <div style="flex-basis: 50%"><h4>Available</h4></div>
      <div
        style="display: flex; flex-direction: column; flex-basis: 4em; margin: 0 1em; justify-content: center;"
      ></div>
      <div style="flex-basis: 50%"><h4>Selected</h4></div>
    </div>
    <div style="display: flex; flex-direction: row;">
      <div style="flex-basis: 50%">
        <div class="wizard-box">
          <ng-container *ngFor="let item of availableItems">
            <div
              *ngIf="item.field"
              [class.current]="
                item && selectedItem && item.field === selectedItem.field
              "
              class="wizard-item"
              (click)="selectedItem = item; selectedGroup = 'availableItems'"
            >
              {{ item.title || item.field }}
            </div>
          </ng-container>
        </div>
      </div>
      <div
        style="display: flex; flex-direction: column; flex-basis: 4em; margin: 0 1em; justify-content: center;"
      >
        <button
          [disabled]="selectedGroup !== 'availableItems'"
          type="button"
          (click)="showItem()"
        >
          &gt;
        </button>
        <button
          type="button"
          (click)="showAllColumns()"
          style="margin-bottom: 3em;"
        >
          &gt;&gt;
        </button>
        <button
          [disabled]="selectedGroup !== 'activeItems'"
          type="button"
          (click)="hideItem()"
        >
          &lt;
        </button>
        <button type="button" (click)="hideAllColumns()">&lt;&lt;</button>
      </div>
      <div style="flex-basis: 50%">
        <div class="wizard-box">
          <ng-container *ngFor="let item of activeItems">
            <div
              *ngIf="item.field"
              [class.current]="
                item && selectedItem && item.field === selectedItem.field
              "
              class="wizard-item"
              (click)="selectedItem = item; selectedGroup = 'activeItems'"
            >
              {{ item.title || item.field }}
              <div>
                <button
                  [disabled]="selectedGroup !== 'activeItems'"
                  type="button"
                  (click)="moveItemDown()"
                >
                  ˅
                </button>
                <button
                  [disabled]="selectedGroup !== 'activeItems'"
                  type="button"
                  (click)="moveItemUp()"
                >
                  ^
                </button>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>`,
})
export class GridWizardRowComponent implements OnChanges {
  @Input() settings: kendo.ui.GridOptions | any;
  @Input() editMode: "columns" | "groups";
  @Output() onChange = new EventEmitter();

  availableItems;
  activeItems;
  selectedItem;
  selectedGroup: "activeItems" | "availableItems";

  moveItemUp() {
    if (!this.selectedItem) {
      return;
    }

    let index: number, itemBeingReplaced;
    index = this.activeItems.indexOf(this.selectedItem);
    itemBeingReplaced = this.activeItems[index - 1];
    if (itemBeingReplaced) {
      const targetArray =
        this.editMode === "columns"
          ? this.settings.columns
          : this.settings.dataSource.group;
      const index1 = targetArray.findIndex(
        (item) => item.field === this.selectedItem.field,
      );
      const index2 = targetArray.findIndex(
        (item) => item.field === itemBeingReplaced.field,
      );
      targetArray[index1] = itemBeingReplaced;
      targetArray[index2] = this.selectedItem;
      this.calcAvailableActiveItems();
      this.onChange.emit();
    }
  }

  moveItemDown() {
    if (!this.selectedItem) {
      return;
    }

    let index: number, itemBeingReplaced;
    index = this.activeItems.indexOf(this.selectedItem);
    itemBeingReplaced = this.activeItems[index + 1];
    if (itemBeingReplaced) {
      const targetArray =
        this.editMode === "columns"
          ? this.settings.columns
          : this.settings.dataSource.group;
      const index1 = targetArray.findIndex(
        (item) => item.field === this.selectedItem.field,
      );
      const index2 = targetArray.findIndex(
        (item) => item.field === itemBeingReplaced.field,
      );
      targetArray[index1] = itemBeingReplaced;
      targetArray[index2] = this.selectedItem;
      this.calcAvailableActiveItems();
      this.onChange.emit();
    }
  }

  hideItem() {
    if (this.editMode === "columns") {
      this.selectedItem.hidden = true;
    } else {
      const index = this.settings.dataSource.group.findIndex(
        (g) => g.field === this.selectedItem.field,
      );
      this.settings.dataSource.group.splice(index, 1);
    }
    this.calcAvailableActiveItems();
    this.onChange.emit();
  }

  showItem() {
    if (this.editMode === "columns") {
      this.selectedItem.hidden = false;
    } else {
      this.settings.dataSource.group.push({
        field: this.selectedItem.field,
      });
    }
    this.calcAvailableActiveItems();
    this.onChange.emit();
  }

  showAllColumns() {
    if (this.editMode === "columns") {
      this.availableItems.forEach((col) => {
        col.hidden = false;
      });
    } else {
      this.settings.dataSource.group.push(
        ...this.availableItems.map((col) => ({ field: col.field })),
      );
    }
    this.calcAvailableActiveItems();
    this.onChange.emit();
  }

  hideAllColumns() {
    if (this.editMode === "columns") {
      this.activeItems.forEach((col) => {
        if (col.field) {
          col.hidden = true;
        }
      });
    } else {
      this.settings.dataSource.group = [];
    }
    this.calcAvailableActiveItems();
    this.onChange.emit();
  }

  calcAvailableActiveItems() {
    if (this.editMode === "columns") {
      this.availableItems = this.settings.columns.filter((col) => col.hidden);
      this.activeItems = this.settings.columns.filter((col) => !col.hidden);
    } else {
      this.availableItems = this.settings.columns.filter(
        (col) =>
          col.groupable &&
          !this.settings.dataSource.group.find((g) => g.field === col.field),
      );
      this.activeItems = this.settings.dataSource.group.map(
        (g) =>
          ({
            ...g,
            title: this.settings.columns.find((col) => col.field === g.field),
          }).title,
      );
    }

    if (this.selectedItem) {
      if (
        this.availableItems.find((col) => col.field === this.selectedItem.field)
      ) {
        this.selectedItem = this.availableItems.find(
          (col) => col.field === this.selectedItem.field,
        );
        this.selectedGroup = "availableItems";
      } else if (
        this.activeItems.find((col) => col.field === this.selectedItem.field)
      ) {
        this.selectedItem = this.activeItems.find(
          (col) => col.field === this.selectedItem.field,
        );
        this.selectedGroup = "activeItems";
      }
    } else {
      this.selectedGroup = null;
    }
  }

  ngOnChanges(changes) {
    if (
      (changes.settings && changes.settings.currentValue) ||
      (changes.editMode && changes.editMode.currentValue)
    ) {
      this.calcAvailableActiveItems();
    }
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-grid/components/grid-wizard-row.component.ts